var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',[_c('section',{staticClass:"space-top space-bottom"},[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticStyle:{"max-width":"700px"}},[_c('HtmlContent',{attrs:{"file":"terms"}})],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }